import { useMemo } from "react"
import { Business as ManufacturerIcon } from '@mui/icons-material'

import { ManufacturerResult, useGetManufacturerLogo } from "interface/manufacturer"

type ManufacturerLogoProps = {
  manufacturer: ManufacturerResult
  size?: 'small' | 'medium'
}
export const ManufacturerLogo = ({
  manufacturer,
  size = 'small'
}: ManufacturerLogoProps) => {
  const manufacturerLogoState = useGetManufacturerLogo(manufacturer.manufacturerId, manufacturer.updateTime)
  const logo = useMemo(
    () => manufacturerLogoState.data ? URL.createObjectURL(manufacturerLogoState.data.blob) : undefined,
    [manufacturerLogoState]
  )
  return logo ? (
    <img
      src={logo}
      alt={manufacturer.manufacturerName ?? '製薬企業'}
      style={size === 'small' ? {
        width: '3rem',
        maxHeight: '3rem',
        objectFit: 'contain',
        verticalAlign: 'middle'
      } : size === 'medium' ? {
        width: '8rem',
        maxHeight: '5rem',
        objectFit: 'contain',
        verticalAlign: 'middle'
      } : undefined}
    />
  ) : (
    <ManufacturerIcon fontSize="medium" color="disabled"/>
  )
}